import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppSettingsService } from '@rillion/core';
import { ButtonComponent } from '@rillion/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { RouterSelectors } from '@rillion/store/router';
import { filter, map } from 'rxjs';

export interface Route {
  link: string;
  text: string;
}

@Component({
  selector: 'rl-topnav',
  standalone: true,
  templateUrl: './topnav.component.html',
  imports: [CommonModule, MatIconModule, RouterModule, MatTooltipModule, ButtonComponent, TranslateModule],
})
export class TopnavComponent {
  @Input() navOpen = false;
  @Input() routes: Route[];
  @Input() user: string;
  @Input() role: string;

  @Output() navOpenChange = new EventEmitter<boolean>();
  @Output() openUser = new EventEmitter<void>();

  disableRoleSelect$ = this.store.select(RouterSelectors.selectRouterState).pipe(
    filter((routerState) => !!routerState),
    map(({ state }) => state?.url?.includes('invoices') && state?.params?.['invoiceId']),
  );

  constructor(
    private readonly appSettingsService: AppSettingsService,
    private readonly store: Store,
  ) {}

  gotoOldExperience() {
    document.location.href = this.appSettingsService.appSettings.oldExperienceUrl;
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.navOpen = !this.navOpen;
    this.navOpenChange.emit(this.navOpen);
  }
}
